export default function getInternalInvoiceUrl(
    customerId: string | undefined,
    orderNumber: string | undefined,
    invoiceId: string | undefined | null,
) {
    if (!customerId || (!orderNumber && !invoiceId) || invoiceId?.toLowerCase() === 'betaling')
        return undefined;

    return `/api/mit-fog/downloadInvoice?customerId=${customerId}&orderNumber=${orderNumber ?? ''}&invoiceId=${invoiceId ?? ''}`;
}
